import React from "react";
import { useSelector } from "react-redux";
import { ReceiptHeader } from "@qgiv/donation-form";
import { currencyString } from "@qgiv/core-js";
import {
    selectReceipt,
    selectReceiptDonationRecipientName,
    selectReceiptTransaction,
} from "../../../../redux/slices/receiptsSlice";
import { selectAllFormSettings } from "../../../../redux/slices/formSettingsSlice";
import ReceiptSubHeading from "../../../Controls/ReceiptHeaderControl/ReceiptSubHeading";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHeader = ({ control }) => {
    const { recurring = {} } = useSelector(selectReceiptTransaction);
    const { status = "" } = recurring;
    const { currency } = useSelector(selectAllFormSettings);
    const entityName = useSelector(selectReceiptDonationRecipientName);
    const receipt = useSelector(selectReceipt);
    const { total = 0 } = receipt;

    const { options = {} } = control;
    const {
        heading = "Ongoing Gift Summary",
        subheading = "Your gift of %AMOUNTWITHFREQUENCY% is making a difference",
    } = options;

    const displayCancelledMessage = status === "deleted";

    const amountText = currencyString(total, currency);
    const frequencyText =
        recurring &&
        recurring.frequency_description &&
        `/${recurring.frequency_description}`;

    const formattedAmountWithFrequency = amountText + frequencyText;

    const recurringSummaryHeaderProps = {
        displayCancelledMessage,
        displayDemoMessage: false,
        displayInvoicedMessage: false,
        displayStartBillingDate: false,
        glyph: "qgiv-calendar-heart-circlebg",
        invoicedMessageText: "You're paying later by invoice",
        receiptHeadingText: heading,
        renderSubHeading: (
            <ReceiptSubHeading
                receiptSubHeading={subheading}
                replaceTags={["%AMOUNTWITHFREQUENCY%", "%RECIPIENTNAME%"]}
                formattedAmountWithFrequency={formattedAmountWithFrequency}
                entityName={entityName}
            />
        ),
        startBillingDateText: "",
    };

    return <ReceiptHeader {...recurringSummaryHeaderProps} />;
};

export default ConnectedRecurringSummaryHeader;
